module.exports = __webpack_public_path__ + "img/hover-instagram.dcbd98a1.png";